import { defineAnimatorComponent } from './extended/Animator';
import { defineMaterialComponent } from './extended/Material';
import { defineMeshColliderComponent } from './extended/MeshCollider';
import { defineMeshRendererComponent } from './extended/MeshRenderer';
import { defineTweenComponent } from './extended/Tween';
import defineNameComponent from './manual/Name';
import defineSyncComponent from './manual/SyncComponents';
import { defineTransformComponent } from './manual/Transform';
export * from './generated/index.gen';
/* @__PURE__ */
export const Transform = (engine) => defineTransformComponent(engine);
/* @__PURE__ */
export const Material = (engine) => defineMaterialComponent(engine);
/* @__PURE__ */
export const Animator = (engine) => defineAnimatorComponent(engine);
/* @__PURE__ */
export const MeshRenderer = (engine) => defineMeshRendererComponent(engine);
/* @__PURE__ */
export const MeshCollider = (engine) => defineMeshColliderComponent(engine);
/* @__PURE__ */
export const Tween = (engine) => defineTweenComponent(engine);
/**
 * @alpha
 */
/* @__PURE__ */
export const Name = (engine) => defineNameComponent(engine);
/**
 * @alpha
 */
/* @__PURE__ */
export const SyncComponents = (engine) => defineSyncComponent(engine);
